import React from "react";

export default function BrandFacet({ handleFilterClick, productBrands }) {
  const wpProductCategory = window.wpProductCategory;
  const plpFacetLabel = wpProductCategory.plpFacetLabel;
  const title =
    plpFacetLabel &&
    Object.keys(plpFacetLabel)?.length > 0 &&
    plpFacetLabel.hasOwnProperty("brand_facet") &&
    plpFacetLabel.brand_facet != ""
      ? plpFacetLabel.brand_facet
      : "Brand";
  return (
    <div class="facet-wrap facet-display">
      <strong>{title}</strong>
      <div className="facetwp-facet">
        {Object.keys(productBrands).map((brand, i) => {
          if (brand && productBrands[brand] > 0) {
            return (
              <div>
                <span
                  id={`brand-filter-${i}`}
                  key={i}
                  data-value={`${brand.toLowerCase()}`}
                  onClick={(e) =>
                    handleFilterClick("brand_facet", e.target.dataset.value)
                  }>
                  {" "}
                  {brand} {` (${productBrands[brand]}) `}
                </span>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}
